"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMagic = exports.__invoke = exports.__delete = exports.__has = exports.__set = exports.__get = void 0;
exports.__get = Symbol("__get");
exports.__set = Symbol("__set");
exports.__has = Symbol("__has");
exports.__delete = Symbol("__delete");
exports.__invoke = Symbol("__invoke");
let warnedInvokeDeprecation = false;
function applyMagic(target, proxyOnly = false) {
    if (typeof target == "function") {
        if (proxyOnly) {
            return proxify(target);
        }
        const PseudoClass = function PseudoClass(...args) {
            if (typeof this == "undefined") { // function call
                let invoke = target[exports.__invoke] || target["__invoke"];
                if (invoke) { // use static __invoke
                    checkType(target, invoke, "__invoke");
                    return invoke
                        ? invoke.apply(target, args)
                        : target(...args);
                }
                let proto = target.prototype;
                invoke = proto[exports.__invoke] || proto.__invoke;
                if (invoke && !warnedInvokeDeprecation) {
                    warnedInvokeDeprecation = true;
                    console.warn("applyMagic: using __invoke without 'static' modifier is deprecated");
                }
                checkType(target, invoke, "__invoke");
                return invoke ? invoke(...args) : target(...args);
            }
            else {
                Object.assign(this, new target(...args));
                return proxify(this);
            }
        };
        Object.setPrototypeOf(PseudoClass, target);
        Object.setPrototypeOf(PseudoClass.prototype, target.prototype);
        setProp(PseudoClass, "name", target.name);
        setProp(PseudoClass, "length", target.length);
        setProp(PseudoClass, "toString", function toString() {
            let obj = this === PseudoClass ? target : this;
            return Function.prototype.toString.call(obj);
        }, true);
        return PseudoClass;
    }
    else if (typeof target === "object") {
        return proxify(target);
    }
    else {
        throw new TypeError("'target' must be a function or an object");
    }
}
exports.applyMagic = applyMagic;
function checkType(ctor, fn, name, argLength = 0) {
    if (fn !== undefined) {
        if (typeof fn != "function") {
            throw new TypeError(`${ctor.name}.${name} must be a function`);
        }
        else if (argLength !== undefined && fn.length !== argLength) {
            throw new SyntaxError(`${ctor.name}.${name} must have ` +
                `${argLength} parameter${argLength === 1 ? "" : "s"}`);
        }
    }
}
function setProp(target, prop, value, writable = false) {
    Object.defineProperty(target, prop, {
        configurable: true,
        enumerable: false,
        writable,
        value
    });
}
function proxify(target) {
    let get = target[exports.__get] || target.__get;
    let set = target[exports.__set] || target.__set;
    let has = target[exports.__has] || target.__has;
    let _delete = target[exports.__delete] || target.__delete;
    checkType(new.target, get, "__get", 1);
    checkType(new.target, set, "__set", 2);
    checkType(new.target, has, "__has", 1);
    checkType(new.target, _delete, "__delete", 1);
    return new Proxy(target, {
        get: (target, prop) => {
            return get ? get.call(target, prop) : target[prop];
        },
        set: (target, prop, value) => {
            set ? set.call(target, prop, value) : (target[prop] = value);
            return true;
        },
        has: (target, prop) => {
            return has ? has.call(target, prop) : (prop in target);
        },
        deleteProperty: (target, prop) => {
            _delete ? _delete.call(target, prop) : (delete target[prop]);
            return true;
        }
    });
}
//# sourceMappingURL=index.js.map